import { inject, Signal } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { AuthStore } from '../state/auth.store';

// Guard-urile citesc starea din store si redirectioneaza cand conditia nu e indeplinita.
function guardFromSignal(allowed: Signal<boolean>, redirectTo: string): boolean | UrlTree {
    return allowed() || inject(Router).parseUrl(redirectTo);
}

// fara sesiune: la login, cu adresa ceruta, ca dupa autentificare sa se revina la ea
export const authGuard: CanActivateFn = (_route, state) => {
    if (inject(AuthStore).isAuthenticated()) {
        return true;
    }
    const router = inject(Router);
    return state.url && state.url !== '/'
        ? router.createUrlTree(['/autorizare'], { queryParams: { returnUrl: state.url } })
        : router.parseUrl('/autorizare');
};

export const isAdminGuard: CanActivateFn = () => guardFromSignal(inject(AuthStore).isAdmin, '/dashboard');

// sectiuni rezervate Avizari (rol 99) si admin (0), de ex. adeverinta de nemembru
export const isAvizariGuard: CanActivateFn = () => guardFromSignal(inject(AuthStore).isAvizari, '/');

